import {LockOutlined} from '@ant-design/icons';
import {ModalForm, ProFormText} from '@ant-design/pro-components';
import {App} from 'antd';
import React from 'react';
import {updatePassword} from '@/services/sys-manager/user-list/api';

type UpdatePasswordModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const UpdatePasswordModal: React.FC<UpdatePasswordModalProps> = ({open, onOpenChange}) => {
  const {message} = App.useApp();

  return (
    <ModalForm
      title="修改密码"
      open={open}
      onOpenChange={onOpenChange}
      width={400}
      modalProps={{destroyOnClose: true}}
      onFinish={async (values: { currentPassword: string; newPassword: string; confirmPassword: string }) => {
        try {
          await updatePassword(values);
          message.success('密码修改成功');
          return true;
        } catch (error) {
          return false;
        }
      }}
    >
      <ProFormText.Password
        name="currentPassword"
        label="当前密码"
        fieldProps={{
          size: 'large',
          prefix: <LockOutlined/>,
        }}
        placeholder="请输入当前密码"
        rules={[{required: true, message: '请输入当前密码'}]}
      />
      <ProFormText.Password
        name="newPassword"
        label="新密码"
        fieldProps={{
          size: 'large',
          prefix: <LockOutlined/>,
        }}
        placeholder="请输入新密码"
        rules={[
          {required: true, message: '请输入新密码'},
          {min: 6, message: '密码长度不能少于6位'},
        ]}
      />
      <ProFormText.Password
        name="confirmPassword"
        label="确认密码"
        fieldProps={{
          size: 'large',
          prefix: <LockOutlined/>,
        }}
        placeholder="请再次输入新密码"
        dependencies={['newPassword']}
        rules={[
          {required: true, message: '请确认新密码'},
          ({getFieldValue}) => ({
            validator(_, value) {
              if (!value || getFieldValue('newPassword') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('两次输入的密码不一致'));
            },
          }),
        ]}
      />
    </ModalForm>
  );
};

export default UpdatePasswordModal;
